import { ReduxState } from '../reducers'
import { createSelector } from 'reselect'
import { CalculCodeStateKeys, CalculContextState } from '@batical/types/src'
import { CalculState } from './CalculsState'

export const selectActiveContextValue = () => {
  return createSelector(
    //@ts-ignore
    (state: ReduxState) => state.calcul[state.calcul.calcul_code] as CalculContextState,
    (_: ReduxState, variable: string) => variable,
    (context: CalculContextState, variable: string) => {
      //@ts-ignore
      return context[variable] as string | number
    }
  )
}

export const selectCalculContext = () => {
  return createSelector(
    (state: ReduxState) => state.calcul,
    (_: ReduxState, calculCode: CalculCodeStateKeys) => calculCode,
    (context, calculCode: CalculCodeStateKeys) => {
      return context[calculCode] as CalculContextState
    }
  )
}

export const selectActiveContextValueWithCalculCode = () => {
  return createSelector(
    (state: ReduxState) => state.calcul,
    (_: ReduxState, calculCode: CalculCodeStateKeys) => calculCode,
    (_: ReduxState, _code: CalculCodeStateKeys, variable: string) => variable,
    (context: CalculState, calculCode: CalculCodeStateKeys, variable: string) => {
      //@ts-ignore
      return context[calculCode][variable]
    }
  )
}

export const selectContextWithCode = () => {
  return createSelector(
    (state: ReduxState) => state.calcul,
    (_: ReduxState, calculCode: CalculCodeStateKeys) => calculCode,
    (context: CalculState, calculCode: CalculCodeStateKeys) => {
      return context[calculCode]
    }
  )
}

export const selectActiveContext = createSelector(
  //@ts-ignore
  [(state: ReduxState) => state.calcul[state.calcul.calcul_code]],
  (value: CalculContextState) => value
)

export const selectCalculs = (state: ReduxState) => state.calcul

export const selectSectionCode = (state: ReduxState) => state.calcul.section_code
export const selectCalculCode = (state: ReduxState) => state.calcul.calcul_code!

export const calculHasAdvancedMode = () => {
  return createSelector(
    (state: ReduxState) => state.calcul,
    (_: ReduxState, calculCode: CalculCodeStateKeys) => calculCode,
    (context: CalculState, calculCode: CalculCodeStateKeys) => {
      const state = context[calculCode]
      const mode = 'mode' in state ? (state as { mode?: 'advanced' | 'simple' | 'none' }).mode : undefined
      return (mode ?? 'none') !== 'none'
    }
  )
}
